export default "__VITE_ASSET__DBWkJM5P__"